import { getTokenAsync } from "../../../hooks/API/getAuthToken";
import { makeHeaders } from "../tools";
import { Articles } from "../types/article";
import { Groups, GroupApiResponse, PartialGroup } from "../types/groups";
import { mapGroupApiResponseToGroup } from "../types/mappers";
import { MEDIAS_SERVICE_URL } from "./service.helper";

const BASE_URL = MEDIAS_SERVICE_URL + "/groups";

export const addGroup = async (group: PartialGroup) => {
  const token = await getTokenAsync();
  if (!token || typeof token !== "string") {
    return;
  }
  const response = await fetch(BASE_URL, {
    method: "POST",
    headers: makeHeaders(token),
    body: JSON.stringify(group),
  });

  if (!response.ok) {
    throw new Error("Network response was not ok.");
  }

  return (await response.text()) as string;
};

export const getGroupsByMedia = async (mediaId: string) => {
  try {
    const token = await getTokenAsync();
    if (!mediaId || !token || typeof token !== "string") {
      return [];
    }
    const response = await fetch(`${BASE_URL}/medias/${mediaId}`, {
      method: "GET",
      headers: makeHeaders(token),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok.");
    }

    const apiResponse = await response.json();
    const groupsApiResponse = apiResponse.groups as GroupApiResponse[];
    const groups: Groups = groupsApiResponse.map(mapGroupApiResponseToGroup);
    return groups;
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return [];
};

export const getArticlesByGroupId = async (
  groupId: string
): Promise<Articles> => {
  const token = await getTokenAsync();
  if (!token) {
    return [];
  }
  try {
    const response = await fetch(`${BASE_URL}/articles/${groupId}`, {
      method: "GET",
      headers: makeHeaders(token),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok.");
    }

    const articles = (await response.json()) as Articles;
    return articles.sort((a1, a2) => (a1.itemName > a2.itemName ? 1 : -1));
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return [];
};

export const updateGroup = async (groupId: string, group: PartialGroup) => {
  const token = await getTokenAsync();
  if (!token || typeof token !== "string") {
    return;
  }
  const url = `${BASE_URL}/${groupId}`;
  const response = await fetch(url, {
    method: "PUT",
    headers: makeHeaders(token),
    body: JSON.stringify(group),
  });

  if (!response.ok) {
    throw new Error("Network response was not ok.");
  }

  return;
};

export const deleteGroupById = async (groupId: string) => {
  const token = await getTokenAsync();
  if (!token || typeof token !== "string") {
    return;
  }
  const response = await fetch(`${BASE_URL}/${groupId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Network response was not ok.");
  }

  return;
};
